import { useEffect, useState } from 'react'
import { InputBase } from '@mui/material'
import type { PropertyInputProps } from '@/objects/property-forms/PropertyInputProps.tsx'

export type NumberPropertyInputProps = PropertyInputProps<number | null>

export function NumberPropertyInput({ value, onValueChange }: NumberPropertyInputProps) {
  const [local, setLocal] = useState(value != null ? String(value) : '')

  useEffect(() => {
    setLocal(value != null ? String(value) : '')
  }, [value])

  function commit() {
    const parsed = local.trim() === '' ? null : Number(local)
    if (parsed !== null && Number.isNaN(parsed)) return
    if (parsed !== value) onValueChange(parsed)
  }

  return (
    <InputBase
      type="number"
      value={local}
      placeholder="—"
      onChange={(e) => setLocal(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur()
      }}
      sx={{ fontSize: 13, width: '100%', p: 0 }}
    />
  )
}
